import { render, staticRenderFns } from "./ImpostazioniTurni.vue?vue&type=template&id=23db5265&"
import script from "./ImpostazioniTurni.vue?vue&type=script&lang=js&"
export * from "./ImpostazioniTurni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports